import { AxiosError } from 'axios';
import toast, { Toaster } from 'react-hot-toast';

export const handleError = (error) => {
  // NOTE:
  // `error?.response?.data?.error.message` will still throw if `error?.response?.data?.error`
  // is undefined, because `.message` is accessed after the optional chain.
  // We must use `?.message` as well.
  const apiError = error?.response?.data?.error;
  const apiMessage = error?.response?.data?.message;

  if (apiError?.message) {
    toast.error(apiError.message);
    return apiError.message;
  } else if (error?.response?.data?.error) {
    toast.error(error?.response?.data?.error);
    return error?.response?.data?.error;
  } else if (apiMessage) {
    toast.error(apiMessage);
    return apiMessage;
  }else {
    toast.error("Something went wrong");
  }
};
